import Vue from 'vue'

import { Form, Icon } from '@bestvike/components-mobile'

Vue.use(Form)
Vue.use(Icon)

Vue.prototype.$APP_ROOT = process.env.VUE_APP_ROOT === '/' ? '' : process.env.VUE_APP_ROOT
Vue.prototype.$APP_FILE = process.env.VUE_APP_FILE_SERVER === '/' ? '' : process.env.VUE_APP_FILE_SERVER
